import type { CmsButton, CmsImage } from '../../types/cms'
import { Box } from '@mui/material'
import DevicesLink from '../DevicesLink'
import { MarkdownText } from 'ui-kit'
import { CardContainer } from './styles'
import { CmsButton as CmsButtonLink } from '../Button'
import FormattedImage from '../FormattedImage'

type ProductCardProps = {
  image?: CmsImage
  text?: string
  button?: CmsButton
  brandNameType?: string
  logo?: CmsImage
  brandName?: string
}

const ProductCard = ({
  image,
  text,
  button,
  brandNameType,
  logo = {},
  brandName = '',
}: ProductCardProps) => {
  return (
    <CardContainer justifyContent="space-between" alignItems="flex-start">
      <DevicesLink href={button?.link ?? ''} passHref legacyBehavior>
        <Box sx={{ cursor: 'pointer' }}>
          <FormattedImage image={image} />
        </Box>
      </DevicesLink>
      {brandNameType === 'text' && brandName ? (
        <MarkdownText>{brandName}</MarkdownText>
      ) : (
        <FormattedImage image={logo} />
      )}
      <MarkdownText>{text}</MarkdownText>
      <CmsButtonLink
        href={button?.link ?? ''}
        backgroundColor={button?.backgroundColour}
        color={button?.textColour}
        fullWidth
      >
        {button?.text}
      </CmsButtonLink>
    </CardContainer>
  )
}

export default ProductCard
